import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import styles from './About.module.scss';
import ButtonPill from '../src/legacy/components/util/ButtonPill/ButtonPill';

/*
OLD DESCRIPTION
Bounce provides a payment platform that facilitates event ticketing and P2P
payments through an intuitive mobile app and professional web app. The platform
caters to a seamless event user experience through integration with ridesharing
and social media applications while enabling the customer to “operate cashless”
and pay for event tickets via their mobile phones. Event hosts benefit from
unique QR code generation and ticket scanning options as well as customer data
analytics and location-based event marketing.{" "}

Additionally, Bounce’s event upgrades provide hosts with unique features such as
event photo galleries, attendee polling, and the ability to provide text updates
to attendees. Finally, Bounce’s comprehensive platform also enables users to
split bills and repay each other through an intuitive fund transfer system.
*/
export const About: React.FC = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation(['marketing']);

  // Prevent hydration issues by not rendering until client-side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Prevent hydration issues by not rendering until client-side
  if (!isMounted) {
    return null;
  }

  return (
  <div className={styles.About}>
    <Head>
      <title>{t('about.page.title')}</title>
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://bouncelife.com/about" />
      <meta property="og:title" content={t('about.page.title')} />
      <meta property="fb:app_id" content="1855802768063770" />
      <meta
        property="og:image"
        content="/img/illustrations/landing/about-image.jpg"
      />
      <meta
        property="og:description"
        content={t('about.page.description')}
      />
    </Head>
    <div className={styles.HeaderBanner}>
      <div className={styles.Container}>
        <h1>{t('about.header.title')}</h1>
        <p>
          {t('about.header.subtitle')}
        </p>
        <ButtonPill type="ButtonWhiteWide" pb="50px" link="/dashboard">
          {t('about.header.getStarted')}
        </ButtonPill>
      </div>
    </div>
    <div className={styles.OurStory}>
      <div className={styles.Container}>
        <h2>{t('about.sections.ourStory.title')}</h2>
        <div className={styles.SectionHeadlineReverse}>
          <img src="/img/illustrations/landing/about-image.jpg" alt="About" />
          <div className={styles.Description}>
            <p>
              {t('about.sections.ourStory.description1')}
            </p>
            <p>
              {t('about.sections.ourStory.description2')}
            </p>
          </div>
        </div>
        <div className={styles.AboutImages}>
          <img src="/img/illustrations/landing/about-1.jpg" alt="About" />
          <img src="/img/illustrations/landing/about-2.jpg" alt="About" />
          <img src="/img/illustrations/landing/about-3.jpg" alt="About" />
        </div>
      </div>
    </div>
    <div style={{ backgroundColor: '#fff', width: '100%' }}>
      <div className={styles.Container}>
        <h2 style={{ paddingTop: '50px' }}>{t('about.sections.ourInitiatives.title')}</h2>
        <div className={styles.OurInitiatives}>
          <div className={styles.Initiative}>
            <h3>{t('about.sections.ourInitiatives.communities.title')}</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              {t('about.sections.ourInitiatives.communities.description')}
            </p>
          </div>
          <div className={styles.Initiative}>
            <h3>{t('about.sections.ourInitiatives.ecosystem.title')}</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              {t('about.sections.ourInitiatives.ecosystem.description')}
            </p>
          </div>

          <div className={styles.Initiative}>
            <h3>{t('about.sections.ourInitiatives.better.title')}</h3>
            <img
              src="/img/illustrations/landing/bounce-ball.svg"
              alt="Bounce"
            />
            <p>
              {t('about.sections.ourInitiatives.better.description')}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.HostEvent}>
      <h2>{t('about.sections.hostEvent.title')}</h2>
      <ButtonPill type="ButtonWhiteWide" link="/dashboard">
        {t('about.sections.hostEvent.getStarted')}
      </ButtonPill>
    </div>
  </div>
  );
};

export async function getStaticProps() {
  return {
    props: {} // will be passed to the page component as props
  };
}

export default About;
